import { SCENE_SCALE } from "../../constants";

export const FONT_SIZE = {
    DEFAULT: 1/24,
    SMALL: 1/36,
    MEDIUM: 1/20,
    LARGE: 1/16
};

export const TEXT_VERTICAL_MARGIN_FACTOR = SCENE_SCALE * 2; // get the vertical margin relative to the font size